<script>
import OfferMixin from '../../../../offer/offer.mixin'

export default {
  name: 'OfferCoupon',
  mixins: [OfferMixin],
  props: {
    offer: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    onlineCheckout() {
      return this.offer.promotionUrl &&
        (this.isCouponTypeOnlineOnly(this.offer.couponType) || this.isCouponTypeOnlineStore(this.offer.couponType))
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="offer.couponCode"
      :class="$style.code"
    >
      {{ offer.couponCode }}
    </div>
    <div v-if="onlineCheckout">
      Use the code above at
      <a
        :href="offer.promotionUrl"
        target="_blank"
        rel="noopener"
      >
        {{ offer.promotionUrl }}
      </a>
      for online checkout.
    </div>
  </div>
</template>

<style lang="scss" module>
  .code {
    display: inline-block;
    padding: 10px;
    margin-bottom: rem(20px);
    font-size: rem(24px);
    font-weight: 600;
    border: .15rem dashed var(--color-dark-gray);
    border-radius: 3px;
  }
</style>
